module.exports = __webpack_public_path__ + "static/media/tell-me-ida.a1092200.mp3";